module.exports = __webpack_public_path__ + "img/import.0d7d985e.svg";